import { Styles } from '@monkvision/types';

export const styles: Styles = {
  container: {
    height: '100dvh',
    width: '100%',
  },
};
